import HotelBenefits from './HotelBenefits';

export default HotelBenefits;
